import { useEffect, useRef, useState } from "react";
import ReloadIcon from "../../../../../components/Icons/RealodIcon";
import './style.css';
import { parseGIF, descompressFrames } from "gifuct-js";
import GifPlay from "./GifPlay";


const PrevImagen = ({ isGifSelected, imagenSelect, setImagenSelect, gifAux, video }) => {

    const [reload, setReload] = useState(false);
    const [boolAux, setboolAux] = useState(false);
    const [repeat, setRepeat] = useState(1);

    const [zoomStyle, setZoomStyle] = useState({});

    const handleMouseMove = (e) => {
        const { offsetX, offsetY, target } = e.nativeEvent;
        const { width, height } = target;

        const xPos = (offsetX / width) * 100;
        const yPos = (offsetY / height) * 100;

        setZoomStyle({
            transform: `scale(1.5)`,
            transformOrigin: `${xPos}% ${yPos}%`,
        });
    };

    function baseGiFToArrayBuffer(base) {
        const base64 = base.spli(",")[1];
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < length; i++) {
            bytes[i] = binary.charCodeAt[i];
        }

        return bytes.buffer;
    }


    const handleMouseLeave = () => {
        setZoomStyle({
            transform: "scale(1)",
        });
    };

    // console.log(gifAux)

    useEffect(() => {
        if (isGifSelected) {
            setTimeout(() => {
                setReload(true)
            }, 3500)
        }
    }, [isGifSelected])

    useEffect(() => {
        if (isGifSelected) {
            if (boolAux) {
                setImagenSelect(gifAux)
            } else {
                setImagenSelect(video)
            }
        }
    }, [boolAux])

    useEffect(() => {
        if (isGifSelected) {
            setImagenSelect(null)
            setTimeout(() => {
                setReload(true)
            }, 3500)

            setboolAux(!boolAux)
        }
    }, [repeat])
    // console.log(imagenSelect)
    // console.log(repeat)

    
    return (
        <div style={{ aspectRatio: "16/9", width: "100%", backgroundColor: "#323639" }} className={`position-relative  ${!isGifSelected && "zoom-container"} `}>

            {
                isGifSelected ? <GifPlay src={video} />
                    :
                    <img
                        key={isGifSelected && repeat}
                        className="w-100 h-100 zoom-image "
                        style={{ objectFit: "contain", ...zoomStyle, }}
                        src={imagenSelect}
                        alt="img-infraccion"

                        onMouseMove={!isGifSelected && handleMouseMove}
                        onMouseLeave={!isGifSelected && handleMouseLeave}
                    />
            }
{/* 
            {
                (isGifSelected && reload) &&
                <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                    onClick={() => { setReload(false); setRepeat(prev => prev + 1) }}
                >
                    <div className="bg-dark p-4 rounded-circle" style={{ cursor: "pointer", zIndex: "1" }}>
                        <ReloadIcon />
                    </div>
                </div>
            } */}
            {/* <img
                key={isGifSelected && repeat}
                className="w-100 h-100 zoom-image "
                style={{ objectFit: "contain", ...zoomStyle, }}
                src={imagenSelect}
                alt="img-infraccion"

                onMouseMove={!isGifSelected && handleMouseMove}
                onMouseLeave={!isGifSelected && handleMouseLeave}
            /> */}
        </div>
    );
}
export default PrevImagen
    ;